import { IDimensions } from 'types'
import { TAiMediaItemType, TMediaItemType } from 'types/media'

export const CURRENT_LANGUAGE = window.CURRENT_LANGUAGE || 'en'
export const CURRENT_HOST = window.WEB_PATH || 'https://www.renderforest.com'
export const HOMEPAGE_TEMPLATES_PATH = `/home/templates/videos`
export const HOMEPAGE_URL = `${CURRENT_HOST}/home/main`
export const AUDIO_URL = `${CURRENT_HOST}/audio`
export const IS_RTL_DIRECTION = CURRENT_LANGUAGE === 'ar'
const LANGUAGE_FOR_URL =
  CURRENT_LANGUAGE === 'en' ? '/' : `/${CURRENT_LANGUAGE}/`
export const REFILL_CREDITS_URL = `${CURRENT_HOST}${LANGUAGE_FOR_URL}refill-credits`

export const TIMELINE_RULER_SLICE_WIDTH = 147
export const SMALL_DESKTOP_SIZE_BREAKPOINT = 1024
export const MOBILE_SIZE_BREAKPOINT = 768
export const SMALL_MOBILE_SIZE_BREAKPOINT = 457
export const TABLET_SIZE_BREAKPOINT = 1366
export const NARROW_SCREEN_SIZE_BREAKPOINT = 1250
export const RECENTLY_USED_ITEMS = 'RecentlyUsedMediaItems'
export const PROJECT_MAX_DURATION = 1800
export const MEDIA_ITEM_MIN_DURATION = 0.25 // seconds

export const ASPECT_RATIO_OPTIONS: Record<string, IDimensions> = {
  landscape: {
    width: 1920,
    height: 1080
  },
  portrait: {
    width: 1080,
    height: 1920
  }
}

export const ASPECT_RATIO_VALUES: Record<string, number> = {
  '16:9': 16 / 9,
  '1:1': 1 / 1,
  '9:16': 9 / 16
}

export const AI_VIDEO_REFERENCE_IMAGE_STORAGE_KEY = 'aiVideoReferenceImage'
export const IMAGE_TO_VIDEO_AI_DATA_STORAGE_KEY = 'image-to-video-ai-data'
export const EXTERNAL_MEDIA_STORAGE_KEY = 'externalMedia'
export const EXTERNAL_MEDIA_QUERY_PARAM = 'mediaId'
export const NEW_PROJECT_ID_PARAM = 'new'
export const ASPECT_RATIO_WARNING_STORAGE_KEY = 'aspect-ratio-warning-shown'

export const PROJECT_AI_MEDIA_TYPES: Record<string, TAiMediaItemType> = {
  aiImage: 'aiImage',
  aiVideo: 'aiVideo'
}

export const PROJECT_MEDIA_TYPES: Record<string, TMediaItemType> = {
  image: 'image',
  video: 'video',
  ...PROJECT_AI_MEDIA_TYPES
}

export const MOBILE_HEADER_WITH_GAP_HEIGHT = 124
export const DEFAULT_MEDIA_DURATION = 5

export const videoTypes = [
  PROJECT_MEDIA_TYPES.video,
  PROJECT_MEDIA_TYPES.aiVideo
]
export const imageTypes = [
  PROJECT_MEDIA_TYPES.image,
  PROJECT_MEDIA_TYPES.aiImage
]

export const MOBILE_HEADER_HEIGHT = 172

export const TRACK_ITEM_CLASS_NAME = 'track-item'
export const TIMELINE_PLUS_BUTTON_CLASS_NAME = 'timeline-plus-button'

export const TIMELINE_START_BOUNDARY = 0

export const ACTION_BUTTONS_CLASS_NAME = 'timeline-action-buttons'

export const GAP_BETWEEN_TIMELINE_AND_PLUS_BUTTON = 64
export const PLAY_HEAD_ANIMATION_NAME = 'playhead-animation'
export const PLAY_HEAD_WRAPPER_PADDING = 20
export const CANVAS_ID = 'main-canvas'

export const AI_VIDEO_MODEL_CODES = {
  SORA_2: 'sora-2',
  HAILUO_02: 'hailuo-2.3',
  SEEDANCE_1_PRO: 'seedance-1.5-pro',
  PIXVERSE: 'pixverse-v5',
  RENDERFOREST: 'forest-1.0'
}

export const PROCESSING_MEDIA_ITEMS = 'processingMediaItems'
export const AI_VIDEO_USER_PREFERENCES = 'aiVideoUserPreferences'

export const COOKIE_STAFF_KEY = '__STAFF_KEY'

export const LOADING_PROGRESS_DATA = 'loadingProgressData'
export const PREMIUM_AI_MODELS_UPGRADE = 'premium-ai-models-upgrade'
export const MIN_PREMIUM_QUALITY = 720

export const GENERAL_UPGRADE_POPUP_TYPE = 'general-upgrade'
export const UPGRADE_POPUP_OPENER_REF = 'v-editor'
export const MAX_LOADING_PROGRESS_DATA_LENGTH = 50

export const NEW_PROJECT_NAME = 'Untitled Project'

export const LINE_HEIGHT_OFFSET = 'calc(100% + 3px)'
